import i18next from 'i18next';

import setupLocale from 'web-app/setup/locale-setup';
import {LOGIN_SCREEN_NAMESPACE} from 'web-app/setup/translations-load-path';

/**
 * Applies the visitor's language, then resolves once the login screen's own file has loaded in it.
 * The global catalogue is left to `GlobalTranslationsGate`, which requests it once the login screen
 * has rendered.
 */
export const loadLoginScreenTranslationsFirst = async () => {
    // No namespace is loaded yet, so the language switch is instant and the login screen's file is
    // fetched in the visitor's language rather than the fallback.
    await setupLocale();
    await i18next.loadNamespaces(LOGIN_SCREEN_NAMESPACE);
};
